import {Service, service, inject} from "./di";
import { SessionStorageService } from "./SessionStorageService";

@service
export class BannerService extends Service {

	isSmartNews() {
		const sessionStorageService = SessionStorageService.getInstance();
		const synd = sessionStorageService.getItem("synd");
		return synd === "smartnews";
	}
}
